const proceduresHelp = {
  '/admin/procedures': {
    title: 'Procédures — Catalogue admin',
    user: [
      {
        heading: 'À quoi sert cette page ?',
        content: 'Le catalogue des templates de procédures techniques utilisées par les techniciens lors des interventions (préparation poste, installation, etc.). Tu vois ici tous les templates de ton organisation et tu peux filtrer par catégorie.',
      },
      {
        heading: 'Comment utiliser ?',
        content: 'Clique sur une ligne pour ouvrir le détail du template. Si tu as les droits d\'administration, tu peux créer un nouveau template via le bouton "+ Nouveau template" ou désactiver des templates existants en cochant les lignes et cliquant "Désactiver".',
      },
    ],
    admin: [
      {
        heading: 'Créer un template',
        content: 'Bouton "+ Nouveau template" → form vide. Le nom est obligatoire, au moins une étape est requise. Pour chaque étape : libellé, type (case à cocher ou saisie texte en P1), durée prévue en minutes, et si l\'étape est obligatoire ou optionnelle.',
      },
      {
        heading: 'Désactivation (soft delete)',
        content: 'Aucun template n\'est jamais supprimé physiquement. La "désactivation" met `is_active=false` ; les runs historiques restent intacts. Le template disparaît de la liste par défaut. Coche "Inclure inactifs" pour les réafficher et éventuellement les réactiver via la fiche détail.',
      },
      {
        heading: 'Multi-organisation',
        content: 'Chaque template appartient à une organisation (METERIS, MCF, SCI). Bascule l\'organisation active dans le sélecteur en haut à droite pour voir le catalogue de l\'autre org.',
      },
    ],
  },

  '/admin/procedures/templates/:id': {
    title: 'Procédures — Édition d\'un template',
    user: [
      {
        heading: 'À quoi sert cette page ?',
        content: 'Affiche le détail d\'un template de procédure : informations générales, étapes (ordre, type, durée) et indicateurs d\'état (actif/inactif).',
      },
    ],
    admin: [
      {
        heading: 'Édition des informations',
        content: 'Modifie le nom, la description, la catégorie et la durée totale prévue dans la section "Informations générales". Les modifications sont enregistrées au clic sur "Enregistrer".',
      },
      {
        heading: 'Gestion des étapes',
        content: 'Section "Étapes" : ajoute une étape via "+ Ajouter une étape". Glisse-dépose une étape sur une autre pour réordonner. Clique l\'icône corbeille pour supprimer. Chaque étape a un libellé, un type, une durée prévue et un flag "Obligatoire".',
      },
      {
        heading: 'Gating séquentiel',
        content: 'À l\'exécution (par un tech sur un ticket), les étapes "obligatoires" sont validées dans l\'ordre : impossible de cocher l\'étape N+1 sans avoir terminé l\'étape N. Une étape marquée "non obligatoire" peut être sautée.',
      },
      {
        heading: 'Durée prévue',
        content: 'La somme des durées des étapes devrait refléter la durée totale du template. C\'est cette durée prévue qui sera comparée à la durée réelle saisie par le technicien lors de l\'exécution. Un dépassement déclenche une justification obligatoire (catégorie + note) avant de pouvoir cocher "Terminer" la procédure.',
      },
    ],
  },

};

export default proceduresHelp;
